import creditEngineRepository, { CreditEngineRepository } from "./CreditEngineRepository";
import { SmsTypes } from "../../utils/SmsTypesConstants";

const APPLICATION_JSON = "application/json";

const resource = "/sms";
export default {
  sendOtp(phoneNumber) {
    const body = {
      smsType: SmsTypes.LOGIN,
      phoneNumber: phoneNumber
    };

    creditEngineRepository.setContentType(APPLICATION_JSON);
    return CreditEngineRepository.post(`${resource}/login`, body);
  },

  sendOTPWithAuth(phoneNumber, smsType, officeId, officeExternalId) {
    const body = {
      smsType: smsType,
      phoneNumber: phoneNumber
    };
    if (officeId) {
      body.officeId = officeId;
    }
    if (officeExternalId) {
      body.officeExternalId = officeExternalId;
    }

    creditEngineRepository.setContentType(APPLICATION_JSON);
    return CreditEngineRepository.post(`${resource}`, body);
  },

  resendBankOtp(loanId) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(
      `${resource}/${loanId}/otp/send`
    );
  },  

};
